import React from "react";
import { useTranslation } from "react-i18next";

import { Loader } from "@common/loader";
import { CopyIcon } from "@common/copyIcon";
import { Clipeable } from "@common/clipeable";
import { Props } from "./types";
import styles from "./styles.scss";

function Export({ data }: Props) {
  const { t } = useTranslation();
  const [isCopying, setIsCopying] = React.useState(false);

  return (
    <div className={styles.export}>
      <div className={styles.button}>
        <Clipeable value={data} clipEnd={() => setIsCopying(false)}>
          {(clipStart) => (
            <div
              className={styles.content}
              onClick={() => {
                setIsCopying(true);
                clipStart();
              }}
            >
              <p>{t("projectLogs.copy")}</p>
              {isCopying ? (
                <div className={styles.copyIcon}>
                  <Loader />
                </div>
              ) : (
                <CopyIcon className={styles.copyIcon} />
              )}
            </div>
          )}
        </Clipeable>
      </div>
    </div>
  );
}

export { Export };
